import "./Button.css";

export default function Button({
  variant,
  children,
  size,
  className,
  href,
  target,
}: {
  variant: "primary" | "secondary";
  size: "small" | "large";
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
}) {
  const commonClasses = `button-${variant} button-${size} ${
    className ? className : ""
  }`;

  if (href) {
    return (
      <a
        href={href}
        className={commonClasses}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
      >
        {children}
      </a>
    );
  }

  return <button className={commonClasses}>{children}</button>;
}
